import { get } from 'lodash';

import * as props from '../prop-names';
import { formatEvent, getEventDate, getDefaultUserProps } from '../helpers';

const getTrackingStateFromUser = user => ({
  Auth: { isAuthenticated: true },
  user: { currentUser: user },
});

// Matches landtrust-ui `subscribedSuccessfully` so GTM `CE - New LT Plus Subscription` can fire.
export const trackSuccessfulSubscriptionEvent = (type, payload) => {
  const event = formatEvent(type, payload);
  const user = payload?.attributes ? payload : payload?.user;
  const trackingState = getTrackingStateFromUser(user);

  event.mp_properties = {
    ...getDefaultUserProps(trackingState),
    [props.SIGNUP_DATE]: getEventDate(),
    [props.EMAIL]: get(user, 'attributes.email'),
    [props.FIRST_NAME]: get(user, 'attributes.profile.firstName'),
    [props.LAST_NAME]: get(user, 'attributes.profile.lastName'),
  };

  return event;
};
